var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrInfographics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 402.74 259.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-2 {\n        font-family: Calibri, Calibri;\n        font-size: 9.26px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #0c344a;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-10, .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-12 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-14 {\n        letter-spacing: .02em;\n      }\n\n      .cls-15 {\n        letter-spacing: .02em;\n      }\n\n      .cls-16 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-17 {\n        letter-spacing: .05em;\n      }\n\n      .cls-18 {\n        stroke-width: .39px;\n      }\n\n      .cls-18, .cls-19, .cls-20, .cls-21, .cls-22 {\n        fill: none;\n      }\n\n      .cls-18, .cls-21, .cls-22 {\n        stroke: #fff;\n      }\n\n      .cls-23 {\n        letter-spacing: 0em;\n      }\n\n      .cls-24 {\n        letter-spacing: 0em;\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-26 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-28 {\n        letter-spacing: .01em;\n      }\n\n      .cls-29 {\n        letter-spacing: .03em;\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        letter-spacing: .03em;\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-34 {\n        letter-spacing: .03em;\n      }\n\n      .cls-11, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40 {\n        fill-rule: evenodd;\n      }\n\n      .cls-41 {\n        letter-spacing: .11em;\n      }\n\n      .cls-35 {\n        fill: #6d66d2;\n      }\n\n      .cls-42 {\n        letter-spacing: 0em;\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        font-family: Calibri-Bold, Calibri;\n        font-size: 10.29px;\n        font-weight: 700;\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-45 {\n        letter-spacing: 0em;\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-36 {\n        fill: #4caefd;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-49 {\n        letter-spacing: .02em;\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-52 {\n        letter-spacing: .16em;\n      }\n\n      .cls-53 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-56 {\n        letter-spacing: 0em;\n      }\n\n      .cls-57 {\n        letter-spacing: 0em;\n      }\n\n      .cls-58 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-59 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-60 {\n        letter-spacing: 0em;\n      }\n\n      .cls-61 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-62 {\n        letter-spacing: 0em;\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-65 {\n        letter-spacing: .01em;\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-67 {\n        letter-spacing: 0em;\n      }\n\n      .cls-68 {\n        letter-spacing: 0em;\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-72 {\n        letter-spacing: .02em;\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-75 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-76 {\n        letter-spacing: 0em;\n      }\n\n      .cls-77 {\n        letter-spacing: 0em;\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-79 {\n        letter-spacing: .01em;\n      }\n\n      .cls-80 {\n        letter-spacing: 0em;\n      }\n\n      .cls-37 {\n        fill: #846cfa;\n      }\n\n      .cls-81 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-82 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-38 {\n        fill: #71c7fe;\n      }\n\n      .cls-83 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-84 {\n        letter-spacing: 0em;\n      }\n\n      .cls-85 {\n        letter-spacing: .02em;\n      }\n\n      .cls-86 {\n        letter-spacing: 0em;\n      }\n\n      .cls-87 {\n        letter-spacing: .02em;\n      }\n\n      .cls-88 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-89 {\n        letter-spacing: 0em;\n      }\n\n      .cls-90 {\n        letter-spacing: .01em;\n      }\n\n      .cls-91 {\n        letter-spacing: 0em;\n      }\n\n      .cls-92 {\n        letter-spacing: 0em;\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-94 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-95 {\n        letter-spacing: .01em;\n      }\n\n      .cls-96 {\n        letter-spacing: .02em;\n      }\n\n      .cls-97 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-98 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-99 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-100 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-101 {\n        letter-spacing: 0em;\n      }\n\n      .cls-102 {\n        letter-spacing: 0em;\n      }\n\n      .cls-103 {\n        letter-spacing: 0em;\n      }\n\n      .cls-104 {\n        letter-spacing: 0em;\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-106 {\n        letter-spacing: 0em;\n      }\n\n      .cls-19 {\n        clip-rule: evenodd;\n      }\n\n      .cls-107 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-108 {\n        letter-spacing: 0em;\n      }\n\n      .cls-109 {\n        letter-spacing: 0em;\n      }\n\n      .cls-110 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-21 {\n        stroke-width: .22px;\n      }\n\n      .cls-111 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-112 {\n        letter-spacing: 0em;\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-114 {\n        letter-spacing: .03em;\n      }\n\n      .cls-115 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-116 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-117 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-22 {\n        stroke-linejoin: round;\n        stroke-width: .98px;\n      }\n\n      .cls-118 {\n        letter-spacing: .02em;\n      }\n\n      .cls-119 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-120 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-39 {\n        fill: #717dfb;\n      }\n\n      .cls-122 {\n        letter-spacing: 0em;\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-124 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-125 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-126 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-127 {\n        letter-spacing: .05em;\n      }\n\n      .cls-128 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-129 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-130 {\n        letter-spacing: .05em;\n      }\n\n      .cls-131 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-132 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-133 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-134 {\n        letter-spacing: .01em;\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-136 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-137 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-140 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-40 {\n        fill: #efefef;\n      }\n\n      .cls-142 {\n        letter-spacing: 0em;\n      }\n\n      .cls-143 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-144 {\n        letter-spacing: .02em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    width: 402.74,
    height: 259.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "94.46 96.17 119.35 96.17 119.35 70.97 94.46 70.97 94.46 96.17 94.46 96.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "130.02 147.6 154.9 147.6 154.9 122.4 130.02 122.4 130.02 147.6 130.02 147.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "188.93 166.63 213.81 166.63 213.81 141.43 188.93 141.43 188.93 166.63 188.93 166.63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "247.33 147.6 272.22 147.6 272.22 122.4 247.33 122.4 247.33 147.6 247.33 147.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0 259.71 402.74 259.71 402.74 0 0 0 0 259.71 0 259.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "282.28 97.84 310.21 97.84 310.21 69.56 282.28 69.56 282.28 97.84 282.28 97.84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "282.28 97.84 310.21 97.84 310.21 69.56 282.28 69.56 282.28 97.84 282.28 97.84"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crop_Marks",
    "data-name": "Crop Marks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M18.25,143.73C9.78,126.31,3.83,107.82,.55,88.68c-2.77-16.14,9.51-30.92,25.75-30.92H107.23c25.32,0,35.85,32.69,15.37,47.71l-65.49,48.01c-13.14,9.63-31.69,4.96-38.85-9.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M295.51,57.76h80.94c16.24,0,28.52,14.78,25.75,30.92-3.28,19.15-9.23,37.64-17.71,55.05-7.16,14.71-25.71,19.38-38.85,9.75l-65.49-48.01c-20.48-15.02-9.96-47.71,15.37-47.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M274.8,112.81l65.34,48.12c13.12,9.66,14.46,28.98,2.81,40.41-6.79,6.66-14.04,12.85-21.71,18.53-7.83,5.8-16.03,11-24.53,15.58-14.34,7.73-32.09,.49-37.11-15.17l-24.97-77.89c-7.81-24.37,19.71-44.64,40.16-29.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M201.21,259.29c-9.64,0-19.21-.67-28.67-2.01-16.12-2.28-26.3-18.66-21.27-34.26l25.04-77.62c7.84-24.29,41.96-24.29,49.79,0l25.04,77.62c5.03,15.6-5.14,31.98-21.27,34.26-9.45,1.34-19.03,2.01-28.67,2.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M142.75,220.28c-5.02,15.66-22.77,22.9-37.11,15.17-8.5-4.58-16.69-9.78-24.53-15.58-7.67-5.68-14.92-11.87-21.71-18.53-11.65-11.43-10.3-30.75,2.81-40.41l65.34-48.12c20.45-15.06,47.98,5.21,40.16,29.58l-24.97,77.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M222.1,154.44c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M280.5,134.9c0,11.65-9.21,21.09-20.57,21.09s-20.57-9.44-20.57-21.09,9.21-21.09,20.57-21.09,20.57,9.44,20.57,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M317.07,84.5c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M127.12,84.5c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M163.18,134.9c0,11.65-9.21,21.09-20.57,21.09s-20.57-9.44-20.57-21.09,9.21-21.09,20.57-21.09,20.57,9.44,20.57,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M222.1,110.7c-.88,0-1.66-.57-1.93-1.43-.34-1.06,.18-2.19,1.18-2.58,9.34-3.65,17.62-9.82,23.92-17.83,.38-.48,.95-.76,1.56-.76,.43,0,.84,.14,1.19,.4,.45,.34,.74,.83,.81,1.4,.07,.57-.08,1.14-.44,1.59-6.75,8.56-15.59,15.16-25.55,19.07-.24,.09-.48,.14-.73,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M250.01,87.42c-.43,0-.83-.13-1.18-.39-.87-.64-1.1-1.84-.51-2.74,5.47-8.41,8.62-18.17,9.1-28.23,.05-1.07,.93-1.9,2.01-1.9,.58,0,1.1,.22,1.48,.63,.39,.41,.59,.96,.56,1.53-.53,10.74-3.91,21.18-9.77,30.19-.38,.58-1.01,.93-1.7,.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M201.23,114.27c-5.32,0-10.62-.71-15.72-2.1-.54-.15-.99-.5-1.26-1-.26-.49-.32-1.06-.14-1.59,.28-.86,1.04-1.42,1.91-1.42,.17,0,.35,.02,.52,.07,4.77,1.3,9.71,1.96,14.7,1.96s9.93-.66,14.7-1.96c.17-.05,.35-.07,.52-.07,.87,0,1.63,.56,1.9,1.4,.18,.55,.13,1.12-.14,1.61-.27,.5-.71,.85-1.26,1-5.11,1.39-10.4,2.1-15.72,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M152.31,87.42c-.69,0-1.32-.35-1.7-.93-5.86-9.01-9.24-19.44-9.77-30.19-.03-.57,.17-1.12,.56-1.53,.38-.4,.9-.63,1.45-.63,1.1,0,1.99,.84,2.04,1.9,.49,10.06,3.64,19.82,9.1,28.24,.58,.9,.36,2.1-.51,2.74l-.04,.03c-.31,.23-.72,.36-1.14,.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M180.28,110.7c-.25,0-.5-.05-.73-.14-9.97-3.91-18.81-10.51-25.55-19.07-.35-.45-.51-1.02-.44-1.59,.07-.57,.36-1.06,.81-1.4,.35-.26,.76-.4,1.19-.4,.61,0,1.18,.28,1.56,.76,6.3,8.02,14.57,14.18,23.92,17.83,1,.39,1.52,1.52,1.18,2.57-.27,.87-1.05,1.45-1.93,1.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M253.58,53.13c0,29.26-23.42,52.97-52.31,52.97s-52.31-23.72-52.31-52.97S172.38,.16,201.27,.16s52.31,23.72,52.31,52.97h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(169.31 45.66) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-76",
    x: 0,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 5.66,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-142",
    x: 11.32,
    y: 0
  }, "il"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 16.45,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 20.05,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 22.61,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 26.21,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 31.86,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 33.92,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 38.55,
    y: 0
  }, "upp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 55.51,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 61.16,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 64.77,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 68.37,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(188.1 58) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 5.65,
    y: 0
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 10.78,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 16.44,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 19.01,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 23.12,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 28.26,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 30.83,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(181.5 70.35) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-103",
    x: 5.14,
    y: 0
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 9.77,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 13.89,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 19.04,
    y: 0
  }, "ll"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 24.18,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-134",
    x: 29.32,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 34.98,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.09,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(17.87 82.54) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 5.14,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 10.28,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 17.48,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 22.11,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 24.17,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 28.8,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 31.89,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 36.51,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(17.87 93.86) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 0,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 7.2,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 11.83,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 16.46,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 18.52,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 22.63,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 27.24,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-127",
    x: 29.3,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 31.87,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 36.5,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 38.56,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 42.16,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 45.25,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 50.4,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-92",
    x: 53.48,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 57.6,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 59.66,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(17.87 105.17) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 0,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 4.63,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 6.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 11.31,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 15.43,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 20.06,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 25.2,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 28.8,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 33.9,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 38,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 41.61,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 43.67,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 46.75,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 51.37,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.63,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(17.87 116.49) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 0,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 3.09,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 6.18,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 10.8,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 15.42,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-128",
    x: 18.52,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 25.72,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 30.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 34.97,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 38.06,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 41.15,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 45.78,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 50.92,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 54.01,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 58.64,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.24,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(17.87 127.79) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 0,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 2.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 6.69,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 9.26,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 14.4,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 19.03,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 23.65,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 25.72,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 30.35,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 32.41,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 37.03,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.14,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(63.88 178.61) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 5.14,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 10.28,
    y: 0
  }, "nn"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 19.54,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 24.17,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 28.28,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 31.37,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-127",
    x: 34.97,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 37.54,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 44.22,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 46.28,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 49.37,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 54,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 56.57,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 58.63,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 63.26,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 66.35,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 70.97,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 74.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 78.7,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 83.32,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 85.37,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(63.88 189.93) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 0,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-92",
    x: 3.6,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 7.72,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 11.32,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 14.41,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 19.04,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 26.24,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 29.84,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 32.92,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 37.54,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-127",
    x: 46.81,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 49.37,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 53.99,
    y: 0
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 58.11,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 61.2,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 65.82,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 68.91,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 73.54,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 78.16,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 80.22,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(63.88 201.25) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 0,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 4.63,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 9.26,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 13.88,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 15.94,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 19.03,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 23.66,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 27.77,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 32.39,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 35.48,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 40.1,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 43.18,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 47.82,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 52.44,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 55.53,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 62.21,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 67.35,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 70.44,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.56,
    y: 0
  }, "s"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(327.45 88.25) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 4.62,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 9.24,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 12.84,
    y: 0
  }, "il"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 16.96,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 21.08,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 23.64,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-82",
    x: 28.26,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 32.9,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 37.51,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 42.15,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 45.24,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 49.86,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 54.49,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 56.55,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.17,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(327.45 99.57) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 0,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 3.09,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 8.23,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 10.3,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 14.41,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 19.03,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 22.12,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 24.18,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-82",
    x: 29.32,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 33.95,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 37.56,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(327.45 110.88) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 0,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 3.6,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 8.23,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 12.86,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 16.97,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 19.03,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 23.65,
    y: 0
  }, "lti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 30.8,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 35.42,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 39.03,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 41.59,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 46.21,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.47,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(327.45 122.2) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 4.11,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 8.73,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 11.82,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 16.44,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-128",
    x: 18.51,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 25.71,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 30.85,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 35.48,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 40.1,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 42.16,
    y: 0
  }, "s"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(268.91 178.61) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 5.14,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 10.28,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 14.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 18,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 21.09,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 26.23,
    y: 0
  }, "ll"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 30.35,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 34.98,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 39.61,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 42.17,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 46.81,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 51.43,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 54.52,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 59.14,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(268.91 189.93) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 4.62,
    y: 0
  }, "cc"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 12.84,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 17.46,
    y: 0
  }, "ss"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 24.67,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 26.73,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 33.41,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 35.47,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 38.56,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 43.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 45.76,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 48.85,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 53.48,
    y: 0
  }, "ll"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.6,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(268.91 201.25) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 4.62,
    y: 0
  }, "ud"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 13.88,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 15.94,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 19.04,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 21.6,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 24.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 27.78,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 32.4,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 36.51,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 40.62,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 42.68,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.32,
    y: 0
  }, "g"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(171.65 198.87) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-128",
    x: 4.11,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 11.31,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 15.93,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 19.02,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 22.11,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 24.68,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 29.3,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 31.36,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 35.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 39.07,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 42.16,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 45.76,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 48.33,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 52.95,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 62.21,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(171.65 210.19) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 0,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 3.6,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 8.23,
    y: 0
  }, "gg"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 16.47,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 21.09,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 24.69,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 29.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 34.93,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 39.56,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-52",
    x: 43.16,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 46.75,
    y: 0
  }, "fo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 54.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 58.07,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(171.65 221.49) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 0,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 4.63,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 9.26,
    y: 0
  }, "tt"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 15.12,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 19.74,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 22.83,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 25.92,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 30.02,
    y: 0
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 34.14,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 38.78,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 40.84,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 44.94,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 49.56,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.62,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(171.65 232.81) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 0,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 5.14,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 9.77,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 12.86,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 16.97,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 22.11,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 29.31,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 33.94,
    y: 0
  }, "s"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M115.27,81.21h-.78v-9.25c0-.11-.09-.2-.19-.2h-11.28c-.05,0-.1,.02-.14,.06l-3.5,3.54s-.06,.09-.06,.14v4.33c0,.11,.09,.2,.19,.2s.19-.09,.19-.2v-4.13h2.72c.43,0,.78-.35,.78-.79v-2.76h10.89v11.03h-6.88l-1.09-2.04c-.17-.32-.5-.52-.86-.52h-6.73c-.54,0-.97,.44-.97,.98v13c0,.54,.44,.98,.97,.98h16.72c.54,0,.97-.44,.97-.98v-12.4c0-.54-.44-.98-.97-.98h0Zm-12.83-5.91h-2.45l2.84-2.87v2.48c0,.22-.17,.39-.39,.39h0Zm12.06,6.3h.78c.32,0,.58,.27,.58,.59v1.19c-.16-.13-.36-.2-.58-.2h-.78v-1.58h0Zm1.36,13c0,.33-.26,.59-.58,.59h-16.72c-.32,0-.58-.27-.58-.59v-13c0-.33,.26-.59,.58-.59h6.73c.21,0,.41,.12,.51,.31l.99,1.86h-4.73c-.11,0-.19,.09-.19,.2s.09,.2,.19,.2h13.22c.32,0,.58,.27,.58,.59v10.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M115.27,81.21h-.78v-9.25c0-.11-.09-.2-.19-.2h-11.28c-.05,0-.1,.02-.14,.06l-3.5,3.54s-.06,.09-.06,.14v4.33c0,.11,.09,.2,.19,.2s.19-.09,.19-.2v-4.13h2.72c.43,0,.78-.35,.78-.79v-2.76h10.89v11.03h-6.88l-1.09-2.04c-.17-.32-.5-.52-.86-.52h-6.73c-.54,0-.97,.44-.97,.98v13c0,.54,.44,.98,.97,.98h16.72c.54,0,.97-.44,.97-.98v-12.4c0-.54-.44-.98-.97-.98h0Zm-12.83-5.91h-2.45l2.84-2.87v2.48c0,.22-.17,.39-.39,.39h0Zm12.06,6.3h.78c.32,0,.58,.27,.58,.59v1.19c-.16-.13-.36-.2-.58-.2h-.78v-1.58h0Zm1.36,13c0,.33-.26,.59-.58,.59h-16.72c-.32,0-.58-.27-.58-.59v-13c0-.33,.26-.59,.58-.59h6.73c.21,0,.41,.12,.51,.31l.99,1.86h-4.73c-.11,0-.19,.09-.19,.2s.09,.2,.19,.2h13.22c.32,0,.58,.27,.58,.59v10.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M103.41,85.54c-2.25,0-4.08,1.86-4.08,4.13s1.83,4.13,4.08,4.13,4.08-1.86,4.08-4.13-1.83-4.13-4.08-4.13h0Zm0,7.88c-2.04,0-3.69-1.68-3.69-3.74s1.66-3.74,3.69-3.74,3.69,1.68,3.69,3.74-1.66,3.74-3.69,3.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M103.41,85.54c-2.25,0-4.08,1.86-4.08,4.13s1.83,4.13,4.08,4.13,4.08-1.86,4.08-4.13-1.83-4.13-4.08-4.13h0Zm0,7.88c-2.04,0-3.69-1.68-3.69-3.74s1.66-3.74,3.69-3.74,3.69,1.68,3.69,3.74-1.66,3.74-3.69,3.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M105.55,88.69h-1.17v-1.18c0-.11-.09-.2-.19-.2h-1.56c-.11,0-.19,.09-.19,.2v1.18h-1.17c-.11,0-.19,.09-.19,.2v1.58c0,.11,.09,.2,.19,.2h1.17v1.18c0,.11,.09,.2,.19,.2h1.56c.11,0,.19-.09,.19-.2v-1.18h1.17c.11,0,.19-.09,.19-.2v-1.58c0-.11-.09-.2-.19-.2h0Zm-.19,1.58h-1.17c-.11,0-.19,.09-.19,.2v1.18h-1.17v-1.18c0-.11-.09-.2-.19-.2h-1.17v-1.18h1.17c.11,0,.19-.09,.19-.2v-1.18h1.17v1.18c0,.11,.09,.2,.19,.2h1.17v1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M105.55,88.69h-1.17v-1.18c0-.11-.09-.2-.19-.2h-1.56c-.11,0-.19,.09-.19,.2v1.18h-1.17c-.11,0-.19,.09-.19,.2v1.58c0,.11,.09,.2,.19,.2h1.17v1.18c0,.11,.09,.2,.19,.2h1.56c.11,0,.19-.09,.19-.2v-1.18h1.17c.11,0,.19-.09,.19-.2v-1.58c0-.11-.09-.2-.19-.2h0Zm-.19,1.58h-1.17c-.11,0-.19,.09-.19,.2v1.18h-1.17v-1.18c0-.11-.09-.2-.19-.2h-1.17v-1.18h1.17c.11,0,.19-.09,.19-.2v-1.18h1.17v1.18c0,.11,.09,.2,.19,.2h1.17v1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.1,91.45h-5.44c-.11,0-.19,.09-.19,.2v1.97c0,.11,.09,.2,.19,.2h5.44c.11,0,.19-.09,.19-.2v-1.97c0-.11-.09-.2-.19-.2h0Zm-.19,1.97h-5.06v-1.58h5.06v1.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M114.1,91.45h-5.44c-.11,0-.19,.09-.19,.2v1.97c0,.11,.09,.2,.19,.2h5.44c.11,0,.19-.09,.19-.2v-1.97c0-.11-.09-.2-.19-.2h0Zm-.19,1.97h-5.06v-1.58h5.06v1.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M109.83,79.04c1.61,0,2.92-1.32,2.92-2.95s-1.31-2.95-2.92-2.95-2.92,1.32-2.92,2.95,1.31,2.95,2.92,2.95h0Zm-1.72-1.08c.4-.56,1.04-.89,1.72-.89s1.32,.33,1.72,.89c-.45,.43-1.05,.69-1.72,.69s-1.27-.26-1.72-.69h0Zm.75-2.27c0-.54,.44-.98,.97-.98s.97,.44,.97,.98-.44,.98-.97,.98-.97-.44-.97-.98h0Zm.97-2.17c1.39,0,2.53,1.15,2.53,2.56,0,.6-.2,1.14-.54,1.58-.31-.4-.73-.7-1.19-.85,.34-.25,.57-.66,.57-1.12,0-.76-.61-1.38-1.36-1.38s-1.36,.62-1.36,1.38c0,.46,.22,.87,.57,1.12-.47,.16-.88,.45-1.19,.85-.34-.44-.54-.98-.54-1.58,0-1.41,1.13-2.56,2.53-2.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M109.83,79.04c1.61,0,2.92-1.32,2.92-2.95s-1.31-2.95-2.92-2.95-2.92,1.32-2.92,2.95,1.31,2.95,2.92,2.95h0Zm-1.72-1.08c.4-.56,1.04-.89,1.72-.89s1.32,.33,1.72,.89c-.45,.43-1.05,.69-1.72,.69s-1.27-.26-1.72-.69h0Zm.75-2.27c0-.54,.44-.98,.97-.98s.97,.44,.97,.98-.44,.98-.97,.98-.97-.44-.97-.98h0Zm.97-2.17c1.39,0,2.53,1.15,2.53,2.56,0,.6-.2,1.14-.54,1.58-.31-.4-.73-.7-1.19-.85,.34-.25,.57-.66,.57-1.12,0-.76-.61-1.38-1.36-1.38s-1.36,.62-1.36,1.38c0,.46,.22,.87,.57,1.12-.47,.16-.88,.45-1.19,.85-.34-.44-.54-.98-.54-1.58,0-1.41,1.13-2.56,2.53-2.56h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.46,127.91c0-.65-.52-1.18-1.17-1.18h-1.77l-2.22-2.62c-.07-.09-.18-.14-.3-.14h-5.06c-.21,0-.39,.18-.39,.39v9.84c0,.65,.52,1.18,1.17,1.18h8.55c.64,0,1.17-.53,1.17-1.18v-6.3Zm-10.11-3.15h4.49l1.67,1.97h-6.15v-1.97h0Zm9.33,9.45c0,.22-.17,.39-.39,.39h-8.55c-.21,0-.39-.18-.39-.39v-6.69h8.94c.21,0,.39,.18,.39,.39v6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M142.46,127.91c0-.65-.52-1.18-1.17-1.18h-1.77l-2.22-2.62c-.07-.09-.18-.14-.3-.14h-5.06c-.21,0-.39,.18-.39,.39v9.84c0,.65,.52,1.18,1.17,1.18h8.55c.64,0,1.17-.53,1.17-1.18v-6.3Zm-10.11-3.15h4.49l1.67,1.97h-6.15v-1.97h0Zm9.33,9.45c0,.22-.17,.39-.39,.39h-8.55c-.21,0-.39-.18-.39-.39v-6.69h8.94c.21,0,.39,.18,.39,.39v6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M152.96,134.61h-5.06c-.11,0-.22,.05-.3,.14l-2.22,2.62h-1.77c-.64,0-1.17,.53-1.17,1.18v6.3c0,.65,.52,1.18,1.17,1.18h8.55c.64,0,1.17-.53,1.17-1.18v-9.84c0-.22-.17-.39-.39-.39h0Zm-.39,10.24c0,.22-.17,.39-.39,.39h-8.55c-.21,0-.39-.18-.39-.39v-6.3c0-.22,.17-.39,.39-.39h8.94v6.69h0Zm0-7.48h-6.15l1.67-1.97h4.49v1.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M152.96,134.61h-5.06c-.11,0-.22,.05-.3,.14l-2.22,2.62h-1.77c-.64,0-1.17,.53-1.17,1.18v6.3c0,.65,.52,1.18,1.17,1.18h8.55c.64,0,1.17-.53,1.17-1.18v-9.84c0-.22-.17-.39-.39-.39h0Zm-.39,10.24c0,.22-.17,.39-.39,.39h-8.55c-.21,0-.39-.18-.39-.39v-6.3c0-.22,.17-.39,.39-.39h8.94v6.69h0Zm0-7.48h-6.15l1.67-1.97h4.49v1.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M139.23,142.2c-.15-.15-.4-.15-.55,0-.15,.15-.15,.39,0,.55l.06,.06c-1.89-.3-3.28-1.95-3.29-3.89v-.02c0-.21-.17-.38-.38-.38,0,0,0,0,0,0-.22,0-.39,.18-.39,.4,0,2.4,1.79,4.42,4.15,4.69l-.14,.15c-.15,.16-.14,.41,0,.56,.15,.15,.39,.15,.54,0l.78-.79c.15-.15,.15-.4,0-.56l-.78-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M139.23,142.2c-.15-.15-.4-.15-.55,0-.15,.15-.15,.39,0,.55l.06,.06c-1.89-.3-3.28-1.95-3.29-3.89v-.02c0-.21-.17-.38-.38-.38,0,0,0,0,0,0-.22,0-.39,.18-.39,.4,0,2.4,1.79,4.42,4.15,4.69l-.14,.15c-.15,.16-.14,.41,0,.56,.15,.15,.39,.15,.54,0l.78-.79c.15-.15,.15-.4,0-.56l-.78-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M147.03,129.17c.15,.16,.4,.16,.55,0,.15-.15,.16-.4,0-.56,0,0,0,0,0,0l-.06-.06c1.89,.3,3.28,1.95,3.29,3.89v.02c0,.21,.17,.38,.38,.38,0,0,0,0,0,0,.22,0,.39-.18,.39-.4,0-2.4-1.79-4.42-4.15-4.69l.14-.15c.15-.15,.16-.4,0-.56-.15-.16-.4-.16-.55,0,0,0,0,0,0,0l-.78,.79c-.15,.15-.15,.4,0,.56l.78,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M147.03,129.17c.15,.16,.4,.16,.55,0,.15-.15,.16-.4,0-.56,0,0,0,0,0,0l-.06-.06c1.89,.3,3.28,1.95,3.29,3.89v.02c0,.21,.17,.38,.38,.38,0,0,0,0,0,0,.22,0,.39-.18,.39-.4,0-2.4-1.79-4.42-4.15-4.69l.14-.15c.15-.15,.16-.4,0-.56-.15-.16-.4-.16-.55,0,0,0,0,0,0,0l-.78,.79c-.15,.15-.15,.4,0,.56l.78,.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M191.83,154.42c-.17,.54-.66,.93-1.25,.93-.72,0-1.31-.59-1.31-1.33s.59-1.33,1.31-1.33c.59,0,1.09,.39,1.25,.93h1.82v-.61c0-.16,.1-.31,.25-.37l1.03-.4c.15-.56,.37-1.09,.65-1.59l-.34-.78h-1.49c-.17,.54-.66,.93-1.25,.93-.72,0-1.31-.59-1.31-1.33s.59-1.33,1.31-1.33c.59,0,1.09,.39,1.25,.93h1.58l1.29-1.3c.11-.12,.29-.15,.43-.08,0,0,.2,.09,.43,.19l-.67-2.38h-4.39c-.17,.54-.66,.93-1.25,.93-.72,0-1.31-.59-1.31-1.33s.59-1.33,1.31-1.33c.59,0,1.09,.39,1.25,.93h4.69c.17,0,.33,.12,.38,.29l.84,2.99c.41-.22,.85-.39,1.3-.51l.4-1.04c.06-.15,.2-.25,.36-.25h1.98c.16,0,.31,.1,.36,.25l.39,1.04c.45,.12,.88,.29,1.3,.51l.84-2.99c.05-.17,.2-.29,.38-.29h4.69c.17-.54,.66-.93,1.25-.93,.72,0,1.31,.59,1.31,1.33s-.59,1.33-1.31,1.33c-.59,0-1.09-.39-1.25-.93h-4.39l-.67,2.38,.43-.19c.15-.07,.32-.03,.43,.08l1.29,1.3h1.53c.17-.54,.66-.93,1.25-.93,.72,0,1.31,.59,1.31,1.33s-.59,1.33-1.31,1.33c-.59,0-1.09-.39-1.25-.93h-1.43c-.13,.3-.34,.78-.34,.78,.28,.5,.5,1.03,.65,1.59l1.02,.4c.15,.06,.25,.21,.25,.37v.61h1.82c.17-.54,.66-.93,1.25-.93,.72,0,1.31,.59,1.31,1.33s-.59,1.33-1.31,1.33c-.59,0-1.09-.39-1.25-.93h-1.82v.61c0,.16-.1,.31-.25,.37l-1.03,.4c-.15,.55-.37,1.09-.65,1.58l.34,.78h1.48c.17-.54,.66-.93,1.25-.93,.72,0,1.31,.59,1.31,1.33s-.59,1.33-1.31,1.33c-.59,0-1.09-.39-1.25-.93h-1.58l-1.29,1.3c-.11,.12-.29,.15-.43,.08,0,0-.2-.09-.43-.19l.67,2.38h4.39c.17-.54,.66-.93,1.25-.93,.72,0,1.31,.59,1.31,1.33s-.59,1.33-1.31,1.33c-.59,0-1.09-.39-1.25-.93h-4.69c-.17,0-.33-.12-.38-.29l-.84-2.99c-.41,.22-.85,.39-1.3,.51l-.39,1.04c-.06,.15-.2,.25-.36,.25h-1.98c-.16,0-.31-.1-.36-.25l-.39-1.04c-.45-.12-.89-.3-1.3-.51l-.84,2.99c-.05,.17-.2,.29-.38,.29h-4.69c-.17,.54-.66,.93-1.25,.93-.72,0-1.31-.59-1.31-1.33s.59-1.33,1.31-1.33c.59,0,1.09,.39,1.25,.93h4.39l.67-2.38-.43,.19c-.15,.07-.32,.03-.43-.08l-1.29-1.3h-1.58c-.17,.54-.66,.93-1.25,.93-.72,0-1.31-.59-1.31-1.33s.59-1.33,1.31-1.33c.59,0,1.09,.39,1.25,.93h1.49c.13-.3,.34-.78,.34-.78-.28-.5-.5-1.03-.65-1.58l-1.03-.4c-.15-.06-.25-.21-.25-.37v-.61h-1.82Zm-1.25-.93c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm11.88-5.51l-.37-.98h-1.45l-.37,.98c-.05,.12-.15,.21-.27,.24-.61,.15-1.18,.39-1.72,.72-.11,.07-.25,.08-.36,.02l-.94-.43-1.02,1.03,.42,.96c.05,.12,.04,.26-.02,.37-.33,.54-.57,1.12-.71,1.74-.03,.13-.12,.23-.24,.28l-.96,.38v1.46l.96,.38c.12,.05,.21,.15,.24,.28,.15,.61,.39,1.2,.71,1.74,.07,.11,.08,.25,.02,.37l-.42,.96,1.02,1.04,.94-.42c.12-.05,.25-.04,.36,.02,.53,.33,1.11,.57,1.72,.72,.13,.03,.23,.12,.27,.24l.37,.98h1.45l.37-.98c.05-.12,.15-.21,.27-.24,.61-.15,1.19-.39,1.71-.72,.11-.07,.25-.08,.36-.03l.94,.42,1.02-1.04-.42-.96c-.05-.12-.04-.26,.02-.37,.33-.54,.57-1.12,.71-1.74,.03-.13,.12-.23,.24-.28l.96-.38v-1.46l-.96-.38c-.12-.05-.21-.15-.24-.28-.14-.62-.38-1.2-.71-1.74-.07-.11-.08-.25-.02-.37l.42-.96-1.02-1.04-.94,.43c-.12,.05-.25,.04-.36-.02-.53-.33-1.11-.57-1.72-.72-.13-.03-.23-.12-.27-.24h0Zm-1.09,11.5c-2.97,0-5.39-2.45-5.39-5.46s2.42-5.46,5.39-5.46,5.39,2.45,5.39,5.46-2.42,5.46-5.39,5.46h0Zm0-.79c2.54,0,4.61-2.1,4.61-4.67s-2.07-4.67-4.61-4.67-4.61,2.1-4.61,4.67,2.07,4.67,4.61,4.67h0Zm-.47-6.24c0,.55-.44,.99-.98,.99s-.98-.44-.98-.99c0-.68,.27-1.29,.71-1.73,.44-.44,1.04-.72,1.71-.72s1.27,.27,1.71,.72c.44,.44,.71,1.06,.71,1.73,0,.48-.14,.93-.38,1.31-.24,.39-.6,.71-1.02,.91h0s-.03,.02-.04,.03h0s-.01,.04-.01,.06v.29c0,.55-.44,.99-.98,.99s-.98-.44-.98-.99v-.29c0-.41,.11-.79,.32-1.11h0c.2-.32,.49-.59,.86-.76,.08-.04,.15-.1,.2-.18h0c.05-.07,.07-.16,.07-.25,0-.13-.05-.25-.14-.33-.09-.09-.2-.14-.33-.14s-.25,.05-.33,.14h0c-.08,.09-.14,.2-.14,.33h0Zm-.78,0c0-.35,.14-.66,.37-.89,.23-.23,.54-.37,.88-.37s.66,.14,.88,.37c.23,.23,.37,.54,.37,.89,0,.25-.07,.48-.19,.68-.13,.2-.31,.37-.52,.47h0c-.23,.11-.41,.27-.53,.47-.13,.2-.19,.44-.19,.69v.29c0,.11,.09,.2,.2,.2s.2-.09,.2-.2v-.29c0-.18,.05-.34,.13-.47,.08-.14,.21-.25,.37-.33,.28-.14,.52-.35,.69-.61h0c.16-.26,.25-.56,.25-.89,0-.46-.18-.87-.48-1.18-.3-.3-.71-.49-1.16-.49s-.86,.19-1.16,.49c-.3,.3-.48,.72-.48,1.18,0,.11,.09,.2,.2,.2s.2-.09,.2-.2h0Zm1.25,3.61c.54,0,.98,.44,.98,.99s-.44,.99-.98,.99-.98-.44-.98-.99,.44-.99,.98-.99h0Zm0,.79c-.11,0-.2,.09-.2,.2s.09,.2,.2,.2,.2-.09,.2-.2-.09-.2-.2-.2h0Zm-8.87-7.91c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm-1.33-4.36c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm20.41,17.79c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm-20.41,0c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm19.02-13.43c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm1.97,4.53c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm-1.92,4.53c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm1.33-13.43c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Zm-19.07,13.43c-.29,0-.53,.24-.53,.54s.24,.54,.53,.54,.53-.24,.53-.54-.24-.54-.53-.54h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M248.97,146.07c.33-1.12,1.35-1.94,2.56-1.94s2.23,.82,2.56,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M252.7,142.94h0c0,.65-.52,1.18-1.17,1.18h0c-.64,0-1.17-.53-1.17-1.18h0c0-.65,.52-1.18,1.17-1.18h0c.64,0,1.17,.53,1.17,1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M253.6,140.24c.99,.67,1.64,1.82,1.64,3.11,0,2.07-1.66,3.76-3.71,3.76s-3.71-1.68-3.71-3.76c0-1.29,.64-2.42,1.62-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.46,146.07c.33-1.12,1.35-1.94,2.56-1.94s2.23,.82,2.56,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M269.19,142.94h0c0,.65-.52,1.18-1.17,1.18h0c-.64,0-1.17-.53-1.17-1.18h0c0-.65,.52-1.18,1.17-1.18h0c.64,0,1.17,.53,1.17,1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M271.73,143.35c0,2.07-1.66,3.76-3.71,3.76s-3.71-1.68-3.71-3.76,1.66-3.76,3.71-3.76,3.71,1.68,3.71,3.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M248.97,129.36c.33-1.12,1.35-1.94,2.56-1.94s2.23,.82,2.56,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M252.7,126.24h0c0,.65-.52,1.18-1.17,1.18h0c-.64,0-1.17-.53-1.17-1.18h0c0-.65,.52-1.18,1.17-1.18h0c.64,0,1.17,.53,1.17,1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M255.24,126.65c0,2.07-1.66,3.76-3.71,3.76s-3.71-1.68-3.71-3.76,1.66-3.76,3.71-3.76,3.71,1.68,3.71,3.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.46,129.36c.33-1.12,1.35-1.94,2.56-1.94s2.23,.82,2.56,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M269.19,126.24h0c0,.65-.52,1.18-1.17,1.18h0c-.64,0-1.17-.53-1.17-1.18h0c0-.65,.52-1.18,1.17-1.18h0c.64,0,1.17,.53,1.17,1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M271.73,126.65c0,2.07-1.66,3.76-3.71,3.76s-3.71-1.68-3.71-3.76,1.66-3.76,3.71-3.76,3.71,1.68,3.71,3.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.8,137.17h-12.05c-.54,0-.97-.44-.97-.98v-2.36c0-.54,.44-.98,.97-.98h12.05c.54,0,.97,.44,.97,.98v2.36c0,.54-.44,.98-.97,.98h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 259.78,
    y1: 135,
    x2: 255.01,
    y2: 135
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "257.23 126.65 258.42 126.65 258.42 132.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "262.32 126.65 261.14 126.65 261.14 132.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "262.32 143.35 261.14 143.35 261.14 137.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "257.23 143.35 258.42 143.35 258.42 137.17"
  }))))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M306.4,89.46v2.28c0,1.13-.91,2.04-2.02,2.04h-2.01l.63,.64c.17,.17,.17,.45,0,.62-.09,.09-.2,.13-.31,.13s-.22-.04-.31-.13l-1.37-1.39s-.02-.02-.03-.03c0,0,0,0-.01-.01,0,0-.01-.01-.01-.02,0,0,0-.01-.01-.02,0,0,0-.01-.01-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.01,0-.03,0-.04,0,0,0,0,0,0s0,0,0,0c0-.01,0-.03,0-.04,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,.01-.02,0,0,0-.01,.01-.02,0,0,0-.01,.01-.02,0,0,0,0,.01-.01,0-.01,.02-.02,.03-.03l1.37-1.39c.17-.17,.45-.17,.62,0,.17,.17,.17,.45,0,.62l-.63,.64h2.01c.63,0,1.15-.52,1.15-1.16v-2.28c0-.24,.2-.44,.44-.44s.44,.2,.44,.44h0Zm-15.53,3.44h-2.77c-.63,0-1.15-.52-1.15-1.16v-1.22l.63,.64c.17,.17,.45,.17,.62,0s.17-.45,0-.62l-1.37-1.39s-.02-.02-.03-.03c0,0,0,0-.01-.01,0,0-.01,0-.02-.01,0,0-.01,0-.02-.01,0,0-.01,0-.02-.01,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.01,0-.03,0-.04,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02,0-.04,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,.01,0,0-.01,0-.02,.01,0,0-.01,.01-.02,.02,0,0,0,0-.01,.01-.01,0-.02,.02-.03,.03l-1.37,1.39c-.17,.17-.17,.45,0,.62,.09,.09,.2,.13,.31,.13s.22-.04,.31-.13l.63-.64v1.22c0,1.13,.91,2.04,2.02,2.04h2.77c.24,0,.44-.2,.44-.44s-.2-.44-.44-.44h0Zm10.44-18.4h3.06c.63,0,1.15,.52,1.15,1.16v2.46l-.63-.64c-.17-.17-.45-.17-.62,0s-.17,.45,0,.62l1.37,1.39c.08,.08,.19,.13,.31,.13s.23-.05,.31-.13l1.37-1.39c.17-.17,.17-.45,0-.62s-.45-.17-.62,0l-.63,.64v-2.46c0-1.13-.91-2.04-2.02-2.04h-3.06c-.24,0-.44,.2-.44,.44s.2,.44,.44,.44h0Zm8.46,9.67c0,2.13-1.71,3.86-3.81,3.86s-3.81-1.73-3.81-3.86,1.71-3.86,3.81-3.86,3.81,1.73,3.81,3.86h0Zm-.87,0c0-1.64-1.32-2.97-2.94-2.97s-2.94,1.33-2.94,2.97,1.32,2.97,2.94,2.97,2.94-1.33,2.94-2.97h0Zm-8.53,11.11c.08,.14,.08,.31,0,.44-.08,.14-.22,.22-.38,.22h-7.79c-.16,0-.3-.08-.38-.22-.08-.14-.08-.31,0-.44l3.89-6.83c.08-.14,.22-.22,.38-.22s.3,.08,.38,.22l3.89,6.83h0Zm-1.13-.22l-3.14-5.5-3.14,5.5h6.28Zm-5.95-18.34v-4.81c0-.24,.2-.44,.44-.44h4.75c.24,0,.44,.2,.44,.44v4.81c0,.24-.2,.44-.44,.44h-4.75c-.24,0-.44-.2-.44-.44h0Zm.87-.44h3.88v-3.93h-3.88v3.93h0Zm-7.94,11.57l-3.37-3.42c-.17-.17-.17-.45,0-.62l3.37-3.42c.08-.08,.19-.13,.31-.13s.23,.05,.31,.13l3.37,3.42c.17,.17,.17,.45,0,.62l-3.37,3.42c-.08,.08-.19,.13-.31,.13s-.23-.05-.31-.13h0Zm-2.45-3.73l2.76,2.79,2.76-2.79-2.76-2.79-2.76,2.79h0Zm8.69,2.2c0-1.59,.95-2.95,2.3-3.55-.5-.43-.81-1.07-.81-1.79,0-1.3,1.04-2.35,2.32-2.35s2.32,1.06,2.32,2.35c0,.71-.32,1.35-.81,1.79,1.35,.59,2.3,1.96,2.3,3.55,0,.24-.2,.44-.44,.44h-6.76c-.24,0-.44-.2-.44-.44h0Zm3.81-3.86h0c.8,0,1.45-.66,1.45-1.47s-.65-1.47-1.45-1.47-1.45,.66-1.45,1.47,.65,1.47,1.45,1.47h0Zm-2.91,3.42h5.82c-.21-1.43-1.44-2.54-2.91-2.54h0c-1.47,0-2.7,1.1-2.91,2.54h0Zm-2.05-11.86s0-.01,0-.02c0,0,0-.01,0-.02,0,0,0-.02,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01-.01-.02,0,0,0-.01-.01-.02,0,0,0-.01-.01-.02,0,0,0,0-.01-.01,0-.01-.02-.02-.03-.03l-1.37-1.39c-.17-.17-.45-.17-.62,0-.17,.17-.17,.45,0,.62l.63,.64h-1.72c-1.11,0-2.02,.92-2.02,2.04v3.22c0,.24,.2,.44,.44,.44s.44-.2,.44-.44v-3.22c0-.64,.51-1.16,1.15-1.16h1.72l-.63,.64c-.17,.17-.17,.45,0,.62,.09,.09,.2,.13,.31,.13s.22-.04,.31-.13l1.37-1.39s.02-.02,.03-.03c0,0,0,0,.01-.01,0,0,.01-.01,.01-.02,0,0,0-.01,.01-.02,0,0,0-.01,.01-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.01,0-.03,0-.04,0,0,0,0,0,0s0,0,0,0c0-.01,0-.03,0-.04h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrInfographics);
export default __webpack_public_path__ + "static/media/EhrInfographics.8e88b146b58b89be2199ff9586ab2a1f.svg";
export { ForwardRef as ReactComponent };